var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: { "margin-top": "-5vh" },
      attrs: {
        visible: _vm.show,
        width: "1340px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c("iframe", {
        staticStyle: { width: "1300px", height: "700px" },
        attrs: { src: _vm.url, frameborder: "0" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb35634", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb35634","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchaseverify/components/BillingDetail.vue
// module id = null
// module chunks = 